export default "__VITE_ASSET__BDViBpBh__"